<template>
  <div>
    <selected-award-amount-icon
      :cartUrl="awardCartFormUrl"
    ></selected-award-amount-icon>
    <award-filter
      v-if="products"
      :products="products"
      :locale="locale"
      :start="start"
      @update-product-list="setProducts"
    ></award-filter>
    <div class="award-list">
      <div>
        <h6 v-if="filtered" class="h6 bold" v-text="resultLabel"></h6>
      </div>
      <ul v-if="filtered">
        <li v-for="product in filtered" :key="product.entity_id">
          <award-card
            :product="product"
          ></award-card>
        </li>
      </ul>
      <div
        v-if="apiError"
        class="col-12 error-box mb-3"
        v-text="translate('lblApiError')"
      ></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import LoyaltyApiConnectorMixin from './mixins/LoyaltyApiConnectorMixin';
import AwardCard from './components/AwardCard.vue';
import AwardFilter from './components/AwardFilter.vue';
import SelectedAwardAmountIcon from './components/SelectedAwardAmountIcon.vue';

export default {
  name: 'AwardList',
  data: () => ({
    products: null,
    selectedAwardAmount: 0,
    apiError: false,
    filtered: [],
    start: performance.now(),
  }),
  props: {
    awardCartFormUrl: String,
    detailView: {
      type: String,
      default: '',
    },
    translations: Object,
    locale: String,
  },
  methods: {
    setProducts(data) {
      this.start = data.start;
      this.filtered = data.products;
    },
  },
  computed: {
    resultLabel() {
      return this.filtered.length === 1
        ? `${this.filtered.length} ${this.translate('lblResult')}`
        : `${this.filtered.length} ${this.translate('lblResults')}`;
    },
  },
  mixins: [LoyaltyApiConnectorMixin],
  async created() {
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    const products = await this.getAwardsApiResult();
    if (products) {
      this.products = products.map((product) => {
        product.href = `${this.detailView}?award=${product.entity_id}`;
        product.created_at = window.moment(product.created_at, 'YYYY-MM-DDThh:mm:ss.SSS').toDate();
        return product;
      }).filter((product) => product.show_teaser);
    }
  },
  components: {
    SelectedAwardAmountIcon,
    AwardCard,
    AwardFilter,
  },
};
</script>

<style lang="scss">
.award-list {
  ul {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding: 0;

    @media (min-width: rem(768px)) {
      gap: rem(18);
    }

    @media (min-width: rem(1280px)) {
      gap: rem(30);
    }
  }

  li {
    display: flex;
    flex: 0 1 100%;
    list-style-type: none;
    margin: 0;
    margin-bottom: rem(30);
    background: white;

    @media (min-width: rem(768)) {
      flex: 0 1 calc((100% / 2) - 9px);
    }

    @media (min-width: rem(1280)) {
      flex: 0 1 calc((100% / 3) - 20px);
    }
  }
}
</style>
